import { dedupeFragments } from '@/utils/dedupe-fragments';
import { getWpGraphqlUrl } from '@/utils/node-utils';

const GRAPHQL_URL = getWpGraphqlUrl();

function getQueryAttrs(query) {
	const [match, type, name] = query.match(
		/((?:query)|(?:mutation)) ([^\(\{\s]+)/
	);
	return {
		type,
		name,
	};
}

export default async function fetchAPI(
	query: any,
	{ variables, auth }: any = {}
) {
	const headers = { 'Content-Type': 'application/json' };

	if (auth?.authToken) {
		headers['Authorization'] = `Bearer ${auth?.authToken}`;
	}

	let result: any = {};

	const endpoint = GRAPHQL_URL;
	const { name } = getQueryAttrs(query);
	const dedupedQuery = dedupeFragments(query);

	try {
		const res = await fetch(endpoint, {
			method: 'POST',
			headers,
			body: JSON.stringify({
				query: dedupedQuery,
				variables,
			}),
		});

		let resText;
		let data, errors;

		try {
			// We first convert the response to text,
			// to be able to console.error the response
			// in case the JSON parsing fails
			resText = await res.text();
			const resJson = JSON.parse(resText);
			data = resJson.data;
			errors = resJson.errors;
		} catch (error) {
			throw new Error(
				`\t- Could not parse json response. \n\t- ${error}\n\t- Text response: \n\t${resText?.slice(
					0,
					1000
				)}...`
			);
		}

		// Make sure to return the data if any
		// even if there are some errors
		if (!!data) result = data;

		if (errors) {
			const errs = errors
				.map((e: any) => `\t- ${e.message} [${e.extensions.category}]`)
				.join('\n');

			throw new Error(errs);
		}
	} catch (errors) {
		const limit = '=================';
		const sep = '-----------------';
		const vars = JSON.stringify(variables);

		(Array.isArray(errors) ? errors : [errors]).map((err) =>
			console.error(`
${limit}
GraphQl API error
${sep}
== date:     ${new Date().toISOString()}
== endpoint: ${endpoint}
== query:
	- name:       ${name}
	- variables:  ${vars ?? '-'}
	- full query: "${dedupedQuery.replace(/[\n\t\s]+/g, ' ')}"
== error:
${err.message}
${limit}
`)
		);
	}

	return result;
}
